import { render, staticRenderFns } from "./SetLocationForm.vue?vue&type=template&id=901796be&lang=pug&"
import script from "./SetLocationForm.vue?vue&type=script&lang=js&"
export * from "./SetLocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports